import { AxiosResponse } from "axios";
import ActionType from "./Action";
import * as actionTypes from './types';
import LicenseService from "../services/use_case/license/LicenseService";
import LicenseResponse from "../services/use_case/license/LicenseResponse";
import CancelRequestError from "../services/CancelRequestError";

let licenseService: LicenseService;

/*
 * LICENSE
 */
export const licenseFetch = (page: number = 1, search: string = "") => {
    
    return async (dispatch: any, getState: any) => {
        
        dispatch( licenseCancelRequest() );
        if(page === 1) dispatch( licenseChangeValue('isLoading', true) );
        
        try {
            let response: AxiosResponse<LicenseResponse> = await licenseService.fetch(page, search);
            let licenseResponse: LicenseResponse = response.data;

            if(page === 1) dispatch( licenseFetchResponse(licenseResponse) );
            else dispatch( licenseFetchNextResponse(licenseResponse) );
        }
        catch(error) {
            if( !(error instanceof CancelRequestError) ) dispatch( licenseChangeValue('isLoading', false) );
        }

    };

}

export const licenseFetchResponse = (payload: LicenseResponse): ActionType<LicenseResponse> => {
    return {
        type: actionTypes.LICENSE_FETCH,
        payload,
    }
}

export const licenseFetchNextResponse = (payload: LicenseResponse): ActionType<LicenseResponse> => {
    return {
        type: actionTypes.LICENSE_FETCH_NEXT,
        payload,
    }
}

export const licenseCancelRequest = () => {

    return async () => {
        licenseService?.cancelRequest();
        licenseService = new LicenseService();
    };

}

export const licenseTransfer = (id: string, trasnferUser: FormData) => {

    return async (dispatch: any, getState: any) => {
    
        try {
            await new LicenseService().transfer(id, trasnferUser);
        }
        catch(error) {
            
        }

    };

}

export const licenseChangeValue = (key: string, value: any): ActionType<any> => {
    return {
        type: actionTypes.LICENSE_CHANGE_VALUE,
        payload: {
            key, 
            value
        },
    }
}